export { BottomFixedBody } from './BottomFixedBody';
